import { useEffect, useMemo, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LangContext, translations } from "@/i18n";
import { setLenis, scrollTopNow } from "@/lib/scroll";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Manifesto from "@/components/Manifesto";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import Method from "@/components/Method";
import Programs from "@/components/Programs";
import Community from "@/components/Community";
import Audiences from "@/components/Audiences";
import Portal from "@/components/Portal";
import Values from "@/components/Values";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Legal from "@/components/Legal";

const Home = () => (
  <main id="contenuto">
    <Hero />
    <Manifesto />
    <Marquee />
    <Stats />
    <Method />
    <Programs />
    <Community />
    <Audiences />
    <Portal />
    <Values />
    <Faq />
    <Contact />
  </main>
);

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollTopNow();
  }, [pathname]);
  return null;
};

export default function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("tt-lang") || "it");

  useEffect(() => {
    localStorage.setItem("tt-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  const value = useMemo(() => ({ lang, setLang, t: translations[lang] }), [lang]);

  return (
    <LangContext.Provider value={value}>
      <BrowserRouter>
        <div className="App">
          <ScrollReset />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<main id="contenuto"><Legal doc="privacy" /></main>} />
            <Route path="/cookie-policy" element={<main id="contenuto"><Legal doc="cookie" /></main>} />
          </Routes>
          <Footer />
          <Toaster theme="dark" position="bottom-center" />
        </div>
      </BrowserRouter>
    </LangContext.Provider>
  );
}
